<template>
  <div class="my-3">
    <hr class="text-dark">
    <div class="my-2">
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">شناسه: {{ item.id }}</span>

      <div class="form-group d-inline-block">
        <input :id="`secure-${item.id}`" type="checkbox" v-model="item.security">
        <label :for="`secure-${item.id}`" class="mx-2 d-inline-block">محافظت شده</label>
      </div>

      <div class="d-inline-block">
        <div class="form-group d-flex align-items-center">
          <label class="mb-0 mr-2">slug:</label>
          <input v-model="item['slug']" type="text" class="form-control">
        </div>
      </div>
    </div>
    <div class="d-block">
      <b-icon class="bg-primary p-1 rounded-pill h3 text-white  my-2" icon="plus" @click="addOption()"/>
      <b-icon class="bg-danger p-1 rounded-pill mx-2 h3 text-white  my-2" icon="trash" @click="deleteQuestion()"/>
    </div>

    <input type="text" class=" form-control" v-model="item.title">

    <div class="form-check form-check-inline my-2 py-2" style="border-bottom: 1px solid #e4e4e4;" v-for="(option,index) in item.options" @click="setActiveValue(index)">

      <div class="image-section mx-2 ">
        <div class="text-center " v-if="option.image != ''">
          <img class="image-input" :src="option.image" alt="">
        </div>


        <div class="custom-file text-left">
          <input @change="uploadImage($event,index)" type="file" class="custom-file-input" id="customFile">


          <label class="custom-file-label" for="customFile">انتخاب عکس پیش فرض</label>
        </div>
      </div>

      <label class="form-check-label mx-2" :for="`${generateHashComputed}_${index}`"> {{ index + 1 }}</label>
      <input :checked="option.value == 1 " class="form-check-input" type="radio"
             :name="generateHashComputed" :id="`${generateHashComputed}_${index}`"
             :value="option.value">
      <input type="text" class="m-2 form-control" v-model="option.label">

      <b-icon class="bg-danger p-1 rounded-pill h3 text-white d-block my-2" icon="trash" @click="deletedOption(index)"/>

    </div>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "RadioBoxInput",
  props: {
    item: {}
  },
  computed: {
    generateHashComputed() {
      return generateHash()
    }
  },
  methods: {
    setActiveValue(index) {

      this.item.options.forEach(item => {
        item['value'] = 0
      })

      this.item.options[index]['value'] = 1
    },
    addOption() {
      let countOptions = this.item.options.length
      this.item.options.push({
        "id": (countOptions + 1),
        "label": "ایتم",
        "value": 0
      })
      this.$forceUpdate()
    },
    deletedOption(index) {
      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {
        this.item.options.splice(index, 1)
        this.$forceUpdate()
      }
    },
    deleteQuestion() {
      this.$emit('removeQuestion')
    },
    async checkFormImageDirectory() {
      let req = await this.$store.dispatch('FileManager/setDirectories')
      let folders = req.data.data
      if (folders.indexOf('form-images') > -1) {
        return true
      }

      return false

    },
    async createFolder() {
      let checker = await this.checkFormImageDirectory()

      if (checker == false) { // create folder if not exists
        let form = {
          name: 'form-images'
        }
        let req = await this.$store.dispatch('FileManager/createDirectory', form)
      }
      return true
    },
    async uploadImage(event, optionIndex) {
      await this.createFolder()
      const file = event.target.files[0];

      let form = {
        uploadDirectory: 'form-images',
        selectedFiles: [file],
      }

      let req = await this.$store.dispatch('FileManager/uploadFiles', form)
      this.item.options[optionIndex]['image'] = req.data.data[0]['file']
      this.$forceUpdate()

    },
  },
  beforeMount() {

    this.item.options.forEach((item, index) => {
      if (Object.keys(item).indexOf('image') == -1) {
        this.item.options[index]['image'] = ""
      }
    })


  }
}
</script>


<style scoped>
.image-input {
  width: 150px;
  height: 150px;
  object-fit: contain;
}
</style>